var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flight-bookings-list',{attrs:{"filters":_vm.query,"page-size":20}})
}
var staticRenderFns = []

export { render, staticRenderFns }